
import { PAGES } from "@/common/consts";

/**
 * Points at the Wordle solver from pages that list 5-letter words.
 *
 * WFW-6748 removed this module from the Wordle results pages, which used to
 * render an "answer" variant of it. Everything that branched on
 * `isWordleResultsPage` went with it, including the guard that suppressed the
 * tracking event for that variant — so the event now fires on every click.
 */
export default {
	name: "WordleCTA",
	props: {
		cssClass: {
			type: String,
			default: "",
		},
	},
	computed: {
		ctaLink() {
			return `${this.$router.resolve({ name: PAGES.WORDLE }).href}/`;
		},
		ctaText() {
			return "Try our Wordle Solver";
		},
		msgText() {
			return "Need help finding today’s Wordle answer?";
		},
	},
	methods: {
		onClick() {
			this.$store.dispatch("tracking/trackEvent", {
				eventCategory: "Wordle CTA",
				eventAction: "Click Wordle CTA button",
			});
		},
	},
};
